import { render, staticRenderFns } from "./labelWidth-editor.vue?vue&type=template&id=39b735cc&scoped=true&"
import script from "./labelWidth-editor.vue?vue&type=script&lang=js&"
export * from "./labelWidth-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b735cc",
  null
  
)

export default component.exports